/**
 * Countries hidden from marketing / shop UIs only (API data unchanged).
 * Matches common API spellings for Åland.
 */
export function normalizeCountryNameForMatch(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
}

export function isExcludedCountryDisplayName(name: string | undefined | null): boolean {
  if (!name) return false
  const n = normalizeCountryNameForMatch(name)
  return n === 'aland islands' || n === 'aaland islands'
}
